import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { LoginModule } from '../components/login/login.module';
import { OtpModule } from '../components/otp/otp.module';
import { UpdateMobileModule } from '../components/update-mobile/update-mobile.module';
import { AuthLayoutComponent } from './auth-layout.component';

@NgModule({
	declarations: [AuthLayoutComponent],
	imports: [SharedModule, LoginModule, OtpModule, UpdateMobileModule],
	exports: [AuthLayoutComponent],
})
export class AuthLayoutModule {}
